import { Pagination, PaginationProps } from '@mui/material';
import React from 'react';
import style from './CustomPagination.module.scss';

const CustomPagination: React.FC<PaginationProps> = (props) => {
  return <Pagination {...props} className={style.pagination} />;
};

export default CustomPagination;
